import { render, staticRenderFns } from "./repartition-bar-item.vue?vue&type=template&id=4ca5a094&scoped=true"
import script from "./repartition-bar-item.vue?vue&type=script&lang=js"
export * from "./repartition-bar-item.vue?vue&type=script&lang=js"
import style0 from "./repartition-bar-item.vue?vue&type=style&index=0&id=4ca5a094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5a094",
  null
  
)

export default component.exports